import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Form} from 'antd';
import {layout, Button} from 'icsoc-antd-ex';
import UnionComponent from 'Components/union/unionComponent';
import tTalkingSkillActions from 'Actions/systemSetting/talkingSkill';
import TableList from './tableList';
import ConfigModal from './modal/configModal';

const {BaseContentMainHeader} = layout;
const FormItem = Form.Item;

class TalkingSkill extends UnionComponent {
  constructor(props) {
    super(props);

    this.state = {
      tableListLoading: false, // 列表loading
      isShowConfigModal: false, // 配置弹框是否可见
    };
  }

  componentWillUnmount() {
    const {actions} = this.props;

    actions.setPageStatus({pageNum: 1, pageSize: 20});
  }

  // 设置配置弹框显示隐藏
  setConfigModalVisible = () => {
    const {isShowConfigModal} = this.state;
    const {actions} = this.props;

    this.setState(
      {
        isShowConfigModal: !isShowConfigModal,
      },
      () => {
        const {isShowConfigModal: currentIsShowConfigModal} = this.state;

        if (!currentIsShowConfigModal) {
          actions.setConfigModalData({});
        }
      },
    );
  };

  render() {
    const {tableListLoading, isShowConfigModal} = this.state;
    const {login} = this.props;
    return (
      <React.Fragment>
        <BaseContentMainHeader title="话术列表">
          <Form layout="inline">
            {
             login.permissionsList.includes('systemSettingTalkingSkill.add') ?
              <FormItem>
                <Button type="success" onClick={this.setConfigModalVisible}>
                  <span>添加话术</span>
                </Button>
              </FormItem>
            : null}
            
          </Form>
        </BaseContentMainHeader>

        <TableList
          loading={tableListLoading}
          getTableList={this.getTableList}
          setConfigModalVisible={this.setConfigModalVisible}
        />

        {isShowConfigModal ? (
          <ConfigModal
            getTableList={this.getTableList}
            setConfigModalVisible={this.setConfigModalVisible}
          />
        ) : null}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  systemSettingTalkingSkill: state.systemSettingTalkingSkill,
  login:state.login
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tTalkingSkillActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TalkingSkill);
